import $ from "jquery"
import PDFPreviewController from "../../pdfPreview/PDFPreviewController";
import ViewTTPagePDFSettingsPreview from "./pdfSettingsPreview/PDFSettingsPreview";
import ParametersFormattingStrategy from "./ParametersFormattingStrategy";

const PDFPreviewLightboxController = function() {};

PDFPreviewLightboxController.prototype = _.create(PDFPreviewController.prototype, {

    _initPdfSettingsPreview: function(elementsIdPrefix)
    {
        this.pdfSettingsPreview = new ViewTTPagePDFSettingsPreview($(this.lightBoxEl).find(".pdfPreviewContainer"), elementsIdPrefix).init();
    },

    _subscribeForEvents: function()
    {
        var self = this;
        $(document).on("viewTT.pdfGenerator.start", function() { self.onGeneratorStart(); });
        $(ViewTTStore).on("generatedPDFChange", function() { self.onGeneratePDFCompleted(); });
    },

    cancelAllExportingProcesses: function ()
    {
        this.pdfViewer.interruptPreview();
    },

    onShow: function()
    {
        this._setTitle(this.createFormattingStrategy(), this._getSelectedParameters());
    },

    createFormattingStrategy: function ()
    {
        return new ParametersFormattingStrategy().init({
            selectorsData: this._getSelectorsData(),
            dateFormat: this.dateFormat
        })
    },

    onGeneratorStart: function()
    {
        this.disableDownloadPDFButton();
        this.pdfSettingsPreview.beforePreviewUpdate();
        this.pdfViewer.showMoire();
    },

    onDownloadPDFBtnClicked: function()
    {
        if (!this.downloadPDFBtnEnabled)
            return;

        $(document).trigger("viewTT.downloadPDF");
    },

    onGeneratePDFCompleted: function()
    {
        this.pdfViewer.showPDF(ViewTTStore.getGeneratedPDF());
        this.enableDownloadPDFButton();
    },

    _getSelectorsData: function()
    {
        return {
            customersProjects: ViewTTStore.getMergedCpList()
        };
    },

    _getSelectedParameters: function()
    {
        return {
            dateParameters: {
                dateRangeSelection: ViewTTStore.getDateRangeConfig()
            },
            statuses: ViewTTPageUtils.isFeatureEnabled(Features["TTA"]) ? ViewTTStore.getFilter().weekApprovalStatuses : null,
            cpSelection: ViewTTStore.getFilter().cpSelection,
            pageOwnerData: {
                otherUser: ViewTTStore.getSelectedUserId() != ViewTTStore.getViewerId(),
                user: ViewTTStore.getSelectedUser()
            }
        };
    }
});

export default PDFPreviewLightboxController;


// WEBPACK FOOTER //
// ./web/js/user/viewtt/PDFPreviewLightboxController.js